export const SHIPPED_STATUS = 'On the way!';
export const DELIVERED_STATUS = 'Delivered';
export const AWAITING_FULFILLMENT_STATUS = 'Being prepared';
export const REFUNDED_STATUS = 'Refunded';
export const CANCELLED_STATUS = 'Canceled';
